import { Injectable, NgZone, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCallingService } from './api-calling.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShareDataService {
  private idleInterval: any;
  private inactivityTime = 0;
  private readonly inactivityTimeout = 3600000; // 1 hour
  private logoutInitiated$ = new BehaviorSubject<boolean>(false);
  private sidebarClicked = new Subject<void>();
  sidebarClicked$ = this.sidebarClicked.asObservable();
  private CommonDataSubject = new BehaviorSubject<any>({
    companyList: [],
    regionList: [],
    areaList: [],
    siteList: [],
  });
  commonData$ = this.CommonDataSubject.asObservable();

  commonDataSharedSignal = signal<any>({
    companyList: [],
    regionList: [],
    areaList: [],
    siteList: [],
  });
  constructor(
    private route: Router,
    private apiCallingService: ApiCallingService,
    private zone: NgZone
  ) {}

  public startInactivityTimer(): void {
    this.idleInterval = setInterval(() => {
      this.zone.run(() => {
        this.inactivityTime += 60 * 1000;
        if (this.inactivityTime >= this.inactivityTimeout) {
          this.logout();
        }
      });
    }, 60 * 1000); // 1 minute interval
  }

  public resetInactivityTimer(event: MouseEvent | KeyboardEvent): void {
    this.inactivityTime = 0;
  }

  stopInterval(): void {
    clearInterval(this.idleInterval);
  }

  logout() {}

  //For sendData and getData
  private dataSubject = new BehaviorSubject<any>(null);
  data$ = this.dataSubject.asObservable();

  sendData(data: any) {
    this.dataSubject.next(data);
  }

  getData() {
    const data = this.dataSubject.getValue();

    this.dataSubject.next([]);
    this.dataSubject.complete();
    return data;
  }

  notifySidebarClicked(): void {
    this.sidebarClicked.next();
  }
  // Getter to check if logout has been initiated
  isLogoutInitiated(): boolean {
    return this.logoutInitiated$.value;
  }

  // Mark logout as initiated
  setLogoutInitiated(value: boolean): void {
    this.logoutInitiated$.next(value);
  }

  // Reset logout flag after successful login
  resetLogoutFlag(): void {
    this.logoutInitiated$.next(false);
  }

  updateCommonData(data: any) {
    this.CommonDataSubject.next(data);
    // this.commonDataSharedSignal.set(data);
  }

  // getCurrentCommonData() {
  //   return this.CommonDataSubject.getValue();
  // }
}
